import { useContext, useEffect, useState } from "react";
import styles from "./styles.module.css";
import { BlocksValue } from "../../../contexts/blocks";
import { StylesValue } from "../../../contexts/styles";
import Card from "./card";
import Add from "./add";

export default function Sidebar({ selected, setSelected }) {
  const blocks = useContext(BlocksValue);
  const stylesValue = useContext(StylesValue);
  const [filter, setFilter] = useState("");
  const [_styles, setStyles] = useState([]);

  useEffect(() => {
    if (filter) {
      setStyles(stylesValue.filter((x) => x.component === filter));
    } else {
      setStyles(stylesValue);
    }
  }, [filter, stylesValue]);
  return (
    <div className={styles.sidebar}>
      <div
        style={{
          padding: "0px 15px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Add setStyle={setSelected} blocks={blocks} />

        <div
          style={{
            fontSize: 12,
            fontWeight: 600,
            color: "#666",
            marginTop: 12,
          }}
        >
          Filter By Block Type
        </div>
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className={styles.select}
        >
          <option value={""}> </option>
          <option disabled>_</option>

          {blocks
            .filter((x) => x.type !== "_component")
            .map((b) => {
              return <option value={b.name}>{b.name}</option>;
            })}
        </select>
      </div>
      <div
        style={{
          flexGrow: 1,
          flexBasis: 0,
          overflowY: "auto",
          padding: "0px 15px",
        }}
      >
        {_styles.map((s) => {
          return (
            <Card
              onClick={(v) => setSelected(v)}
              active={s.id === selected.id}
              style={s}
              key={s.id}
            />
          );
        })}
      </div>
    </div>
  );
}
